var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiFicha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "certificate-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.75 13.875H11.25M5.25 11.25H12.75M3.75 1.5H14.25C15.0784 1.5 15.75 2.24619 15.75 3.16667V14.8333C15.75 15.7538 15.0784 16.5 14.25 16.5H3.75C2.92157 16.5 2.25 15.7538 2.25 14.8333V3.16667C2.25 2.24619 2.92157 1.5 3.75 1.5ZM8.9982 4.65895C8.47337 4.0746 7.59818 3.91741 6.94061 4.4525C6.28303 4.9876 6.19045 5.88224 6.70685 6.5151C7.22325 7.14796 8.9982 8.625 8.9982 8.625C8.9982 8.625 10.7732 7.14796 11.2896 6.5151C11.806 5.88224 11.7247 4.98197 11.0558 4.4525C10.3869 3.92304 9.52303 4.0746 8.9982 4.65895Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiFicha);
export default __webpack_public_path__ + "static/media/mi-ficha.21c5b4153d70d93ef84d6cdfc511be4b.svg";
export { ForwardRef as ReactComponent };